import React, { useEffect, useState } from "react";
import "./reschedule.css";
import Topheader from "../topheader/topheader";
import tutorimage from "../../assets/image/tutor1.png";
import axios from "axios";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate } from "react-router-dom";

const MySwal = withReactContent(Swal);

const Reschedule = () => {
  const navigate = useNavigate();
  const [appointments, setAppointments] = useState([]);
  const [serviceDetails, setServiceDetails] = useState({});
  const [rescheduleStates, setRescheduleStates] = useState({});
  const [feedbackStates, setFeedbackStates] = useState({});
  const [newDateTimes, setNewDateTimes] = useState({});
  const studentid = localStorage.getItem("studentid");

  const showToast = (icon, title, text) => {
    MySwal.fire({
      toast: true,
      position: "center",
      icon: icon,
      text: text,
      title: title,
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  };

  const [doctorRatings, setDoctorRatings] = useState([]);

  useEffect(() => {
    const fetchDoctorRatings = async () => {
      try {
        const res = await axios.get(
          "https://apifrwrd.smplyrefer.com/api/reviewsdoctorcount"
        );
        setDoctorRatings(res.data || []);
      } catch (err) {
        console.error("Error fetching doctor ratings:", err);
      }
    };

    fetchDoctorRatings();
  }, []);

  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const res = await axios.get(
          `https://apifrwrd.smplyrefer.com/api/appointments/${studentid}`
        );
        const appointments = res.data?.data?.results || [];
        setAppointments(appointments);
        console.log("appointmentsappointments", appointments);

        appointments.forEach(async (appt) => {
          const serviceId = appt.service?.id;
          if (serviceId) {
            try {
              const serviceRes = await axios.get(
                `https://apifrwrd.smplyrefer.com/api/services/${serviceId}`
              );
              console.log("appointmentsappointments1", serviceRes);

              setServiceDetails((prev) => ({
                ...prev,
                [serviceId]: serviceRes.data,
              }));
            } catch (error) {
              console.error(`Error fetching service ${serviceId}:`, error);
            }
          }
        });
      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    };

    fetchAppointments();
  }, [studentid]);

  const toggleReschedule = (id) => {
    setRescheduleStates((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleFeedback = (id) => {
    setFeedbackStates((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleRescheduleSubmit = async (appointmentId, serviceId, topic) => {
    const newStart = newDateTimes[appointmentId];
    if (!newStart) return alert("Please select a new date & time.");

    const startTime = new Date(newStart);
    const now = new Date();

    if (startTime <= now) {
      showToast(
        "warning",
        "Invalid Time",
        "Please choose a future date and time."
      );
      return;
    }

    const finishTime = new Date(startTime.getTime() + 60 * 60000); // +1 hour

    const payload = {
      start: startTime.toISOString(),
      finish: finishTime.toISOString(),
      topic: topic,
      service: serviceId,
    };

    try {
      await axios.put(
        `https://apifrwrd.smplyrefer.com/api/appointments/${appointmentId}`,
        payload
      );
      showToast("success", "Success", "Appointment rescheduled successfully");
      setRescheduleStates((prev) => ({ ...prev, [appointmentId]: false }));
    } catch (error) {
      console.error("Error updating appointment:", error);
      showToast("error", "Error", "Failed to update appointment.");
    }
  };

  const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString();
  const formatTime = (dateStr) =>
    new Date(dateStr).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

  const [selectedRating, setSelectedRating] = useState(0);
  const [message, setMessage] = useState("");

  const Ratingdoctor = async (contractorNameid) => {
    const payload = {
      user_id: studentid,
      doctor_id: contractorNameid,
      rating: selectedRating,
      message: message,
    };
    try {
      await axios.post(
        `https://apifrwrd.smplyrefer.com/api/reviewsdoctor`,
        payload
      );
      showToast("success", "Success", "Rating successfully submitted");
      setSelectedRating(0); // reset after submit
      setMessage("");
      navigate("/dashbord");
      // toggleFeedback(appt.id); // close feedback box
    } catch (error) {
      console.error("Error updating rating:", error);
      showToast("error", "Error", "Failed to submit rating.");
    }
  };

  return (
    <>
      <Topheader />
      <div className="body-with-fixed-header">
        <div className="container mt-4">
          <div className="row">
            {appointments.map((appt) => {
              const serviceId = appt.service?.id;
              const contractorName =
                serviceDetails[serviceId]?.conjobs?.[0]?.name || "Loading...";
              const contractorNameid =
                serviceDetails[serviceId]?.conjobs?.[0]?.contractor || null;

              const doctorRating = doctorRatings.find(
                (r) => r.doctor_id === contractorNameid
              );
              const averageRating = doctorRating?.average_rating
                ? parseFloat(doctorRating.average_rating).toFixed(1)
                : "N/A";

              return (
                <div className="col-lg-4 col-md-6 col-12 mb-4" key={appt.id}>
                  <div className="card shadow h-100">
                    <div className="card-body d-flex flex-column justify-content-between">
                      <div className="profile-section d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center">
                          <div>
                            <h5 className="mb-1">{contractorName}</h5>
                            <small>{appt.topic || "Subject"}</small>
                            <div>
                              <strong>Rating:</strong> {averageRating} ⭐
                            </div>
                          </div>
                        </div>
                        <span className={`status-tag ${appt.status}`}>
                          {appt.status}
                        </span>
                      </div>

                      <div className="info-section mb-3">
                        <p>
                          <i className="fa fa-map-marker"></i> Online
                        </p>
                        <p>
                          <strong>Date:</strong> {formatDate(appt.start)}
                        </p>
                        <p>
                          <strong>Time:</strong> {formatTime(appt.start)} -{" "}
                          {formatTime(appt.finish)}
                        </p>
                        <p>
                          <strong>Duration:</strong> 60 min
                        </p>
                      </div>

                      <div className="button-group mb-2">
                        <button
                          className="btn btn-primary btn-sm mr-2"
                          onClick={() => toggleReschedule(appt.id)}
                        >
                          Reschedule
                        </button>

                        {appt.status?.toLowerCase().trim() !== "complete" && (
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => toggleFeedback(appt.id)}
                          >
                            Review
                          </button>
                        )}
                      </div>

                      {rescheduleStates[appt.id] && (
                        <div className="reschedule-section mb-2">
                          <label className="d-block mb-1">
                            Select New Date & Time:
                          </label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            min={new Date().toISOString().slice(0, 16)}
                            value={newDateTimes[appt.id] || ""}
                            onChange={(e) =>
                              setNewDateTimes((prev) => ({
                                ...prev,
                                [appt.id]: e.target.value,
                              }))
                            }
                          />
                          <button
                            className="btn btn-success btn-sm mt-2"
                            onClick={() =>
                              handleRescheduleSubmit(
                                appt.id,
                                serviceId,
                                appt.topic
                              )
                            }
                          >
                            Submit New Time
                          </button>
                        </div>
                      )}

                      {feedbackStates[appt.id] && (
                        <div className="feedback-section">
                          <h6>Feedback</h6>
                          <p>
                            What are your thoughts on the class you attended?
                          </p>

                          <label>Rate your Class:</label>
                          <div
                            className="stars mb-2"
                            style={{ cursor: "pointer" }}
                          >
                            {[1, 2, 3, 4, 5].map((num) => (
                              <span
                                key={num}
                                className={`star ${
                                  num <= selectedRating ? "selected" : ""
                                }`}
                                onClick={() => setSelectedRating(num)}
                                style={{
                                  fontSize: "24px",
                                  color:
                                    num <= selectedRating ? "#ffc107" : "#ccc",
                                  marginRight: "4px",
                                }}
                              >
                                ★
                              </span>
                            ))}
                          </div>

                          <textarea
                            className="form-control"
                            rows="3"
                            placeholder="Do you have any thoughts you’d like to share?"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                          />
                          <div className="feedback-buttons mt-2 d-flex justify-content-end">
                            <button
                              className="btn btn-secondary btn-sm mr-2"
                              onClick={() => toggleFeedback(appt.id)}
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => Ratingdoctor(contractorNameid)}
                              disabled={selectedRating === 0}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Reschedule;
